'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { HStack } from '@/components/Layout';
import { AuthenticationSettingsNavigation } from './-components/AuthenticationSettingsNavigation';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/settings')({
  component: AuthenticationSettingsLayout
});
function AuthenticationSettingsLayout() {
  return <HStack className="items-start gap-10 px-12 py-6">
      <AuthenticationSettingsNavigation />
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </HStack>;
}